<template>
    <div>
        <v-btn color="primary" :to="{name: 'home'}">
            {{ $t('book_other_services') }}
        </v-btn>
    </div>
</template>

<script lang="ts">
    import {Vue, Component} from 'vue-facing-decorator'

    @Component
    export class ConfirmationPageButtons extends Vue {}

    export default ConfirmationPageButtons
</script>
